import React from 'react';
import { View } from 'react-native';
import SectionDivider from 'shared/components/vxl/divider/SectionDivider/SectionDivider';
import ListItemGroup, {
  ListItemGroupItem,
} from 'shared/components/vxl/ListItemGroup/ListItemGroup';

export interface DiscoverMoreTilesProps {
  sectionLabel?: string;
  items: ListItemGroupItem[];
}

const DiscoverMoreTiles = ({ sectionLabel, items }: DiscoverMoreTilesProps) => {
  return (
    <View>
      {sectionLabel ? <SectionDivider labelText={sectionLabel} /> : null}
      <ListItemGroup items={items} />
    </View>
  );
};

export default DiscoverMoreTiles;
